"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PARAMETROS_BUSCA = exports.GRUPOS_SANGUINEOS = exports.FATORES_RH = exports.CONTATO = void 0;
var CONTATO = exports.CONTATO = {
  CATEGORIA: {
    TELEFONE_RESIDENCIAL: 1,
    TELEFONE_CELULAR: 2,
    TELEFONE_COMERCIAL: 3,
    EMAIL: 4,
    FAX: 5,
    OUTRO: 6
  }
};
var PARAMETROS_BUSCA = exports.PARAMETROS_BUSCA = {
  NOME: 'BuscaPaciente_nome',
  CPF: 'BuscaPaciente_cpf',
  CNS: 'BuscaPaciente_cns'
};
var GRUPOS_SANGUINEOS = exports.GRUPOS_SANGUINEOS = ['A', 'B', 'AB', 'O'];
var FATORES_RH = exports.FATORES_RH = ['+', "-"];